import React from 'react';

class Terms extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <React.Fragment>
                <div className="post_tags text-center">
                    {this.props.terms.map((item, i) =>
                        <a href={item.url} className="badge badge-pill badge-secondary" key={i}>{item.name}</a>
                    )}
                </div>
            </React.Fragment>
        )
    }
}

export default Terms;